import {Component} from '@angular/core';

@Component({
  selector: 'atom-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
}
